export default __webpack_public_path__ + "static/media/UploadImagingFile.594eb948.svg";